import { Layout } from 'antd';
import { BaseLayoutComponent } from '@components';
import CustomerStatsCards from './CustomerStatsCards';
import LeadStatusTable from './CustomerStatusTable';
import HeadingTypography from '../../shared/Typography/Heading';
import DateRange from '../../shared/dataRange';
import useGetLeadsBasicData from 'src/app/hooks/useGetLeadsBasicData';
import { useCustomerContext } from 'src/app/contexts/customer';

const { Content } = Layout;

export const CustomerPageComponent = () => {
    const { setDate } = useCustomerContext();
    useGetLeadsBasicData();

    return (
        <>
            <BaseLayoutComponent
                children={
                    <Content className="m-5 bg">
                        <div className="flex justify-between">
                            <HeadingTypography fontSize={24}>Customer</HeadingTypography>
                            <DateRange setDate={setDate} />
                        </div>
                        <CustomerStatsCards />
                        <LeadStatusTable />
                    </Content>
                }
            />
        </>
    );
};
